import type { FC } from "react";
import { useProjectJobQuestionsFeedbackByIdQuery } from "../../../api/entities/projectFeedback.js";
import { SuggestionsWidget } from "../feedback/suggestionsWidget.js";

export interface QuestionsSuggestionsWidgetProps {
  projectId: string;
}

export const QuestionsSuggestionsWidget: FC<QuestionsSuggestionsWidgetProps> = (
  props,
) => {
  const feedback = useProjectJobQuestionsFeedbackByIdQuery(props.projectId);

  return (
    <SuggestionsWidget
      isLoading={feedback.isLoading}
      isFetching={feedback.isFetching}
      suggestions={feedback.data?.suggestions.map(
        (suggestion) => suggestion.suggestion,
      )}
      onRefreshClick={feedback.refetch}
    />
  );
};
